import type { Message } from '../../../i18n/types';

/** Texts of the autotest catalogue by product team; keys start with `automation.catalog.`. */
export const automationCatalogEn = {
  'automation.catalog.view': 'View',
  'automation.catalog.viewCatalog': 'Catalogue by team',
  'automation.catalog.viewRepos': 'Repositories',
  'automation.catalog.tree': 'Teams and areas',
  'automation.catalog.qa': 'QA: {names}',
  'automation.catalog.search': 'Find a scenario or a case key',
  'automation.catalog.searchResults': 'Found for «{query}»',
  'automation.catalog.nothingFound': 'Nothing here.',
  'automation.catalog.empty': 'No autotests yet',
  'automation.catalog.emptyHint':
    'Bring the registry over from TestRun or scan a repository — scenarios appear here by team.',
  'automation.catalog.ip': 'IE',
  'automation.catalog.too': 'LLP',
  'automation.catalog.steps': { one: '{count} check', other: '{count} checks' },
  'automation.catalog.failedAt': 'failed at: {step}',
  'automation.catalog.status.passed': 'Passed',
  'automation.catalog.status.failed': 'Failed',
  'automation.catalog.status.skipped': 'Skipped',
  'automation.catalog.status.none': 'Not run',
  'automation.catalog.noSteps': 'The steps are not known yet — scan the repository.',
  'automation.catalog.openRun': 'Run #{id}',
  'automation.catalog.neverRun': 'Not in any finished run yet',
  'automation.catalog.openProject': 'In the repository «{name}»',
  'automation.catalog.move': 'Move',
  'automation.catalog.moveTitle': 'Move «{name}»',
  'automation.catalog.moveHint':
    'Choose the team area this scenario belongs to. The choice survives rescans.',
  'automation.catalog.moveBack': 'Back by tags',
  'automation.catalog.moveSave': 'Move',
  'automation.catalog.moved': 'Scenario moved',
  'automation.catalog.area': 'Area',
  'automation.catalog.runFolder': 'Run folder',
  'automation.catalog.runTitle': 'Run «{name}»?',
  'automation.catalog.runHint':
    'Scenarios: {scenarios}, one pipeline per repository ({repos}). Accounts come from each project’s test data.',
  'automation.catalog.runStarted': 'Started: {list}',
  'automation.catalog.passing': { one: '{count} passes', other: '{count} pass' },
  'automation.catalog.failing': { one: '{count} fails', other: '{count} fail' },
  'automation.catalog.notRun': '{count} not run',
  'automation.catalog.scenarios': { one: '{count} scenario', other: '{count} scenarios' },
  'automation.catalog.checks': { one: '{count} check', other: '{count} checks' },
  'automation.catalog.repos': { one: '{count} repository', other: '{count} repositories' },
} as const;

export const automationCatalogRu: Record<keyof typeof automationCatalogEn, Message> = {
  'automation.catalog.view': 'Вид',
  'automation.catalog.viewCatalog': 'Каталог по командам',
  'automation.catalog.viewRepos': 'Репозитории',
  'automation.catalog.tree': 'Команды и разделы',
  'automation.catalog.qa': 'QA: {names}',
  'automation.catalog.search': 'Найти сценарий или ключ кейса',
  'automation.catalog.searchResults': 'Найдено по «{query}»',
  'automation.catalog.nothingFound': 'Здесь ничего нет.',
  'automation.catalog.empty': 'Автотестов пока нет',
  'automation.catalog.emptyHint':
    'Перенесите реестр из TestRun или просканируйте репозиторий — сценарии появятся здесь по командам.',
  'automation.catalog.ip': 'ИП',
  'automation.catalog.too': 'ТОО',
  'automation.catalog.steps': {
    one: '{count} проверка',
    few: '{count} проверки',
    many: '{count} проверок',
    other: '{count} проверки',
  },
  'automation.catalog.failedAt': 'упал: {step}',
  'automation.catalog.status.passed': 'Прошёл',
  'automation.catalog.status.failed': 'Упал',
  'automation.catalog.status.skipped': 'Пропущен',
  'automation.catalog.status.none': 'Не запускался',
  'automation.catalog.noSteps': 'Шаги пока неизвестны — просканируйте репозиторий.',
  'automation.catalog.openRun': 'Прогон #{id}',
  'automation.catalog.neverRun': 'Ещё не был ни в одном завершённом прогоне',
  'automation.catalog.openProject': 'В репозитории «{name}»',
  'automation.catalog.move': 'Переместить',
  'automation.catalog.moveTitle': 'Переместить «{name}»',
  'automation.catalog.moveHint':
    'Выберите раздел команды, к которому относится сценарий. Выбор сохраняется и при пересканировании.',
  'automation.catalog.moveBack': 'Вернуть по тегам',
  'automation.catalog.moveSave': 'Переместить',
  'automation.catalog.moved': 'Сценарий перемещён',
  'automation.catalog.area': 'Раздел',
  'automation.catalog.runFolder': 'Запустить папку',
  'automation.catalog.runTitle': 'Запустить «{name}»?',
  'automation.catalog.runHint':
    'Сценариев: {scenarios}, по одному пайплайну на репозиторий ({repos}). Аккаунты — из тестовых данных каждого проекта.',
  'automation.catalog.runStarted': 'Запущено: {list}',
  'automation.catalog.passing': {
    one: '{count} проходит',
    few: '{count} проходят',
    many: '{count} проходят',
    other: '{count} проходят',
  },
  'automation.catalog.failing': {
    one: '{count} падает',
    few: '{count} падают',
    many: '{count} падают',
    other: '{count} падают',
  },
  'automation.catalog.notRun': 'не запускались: {count}',
  'automation.catalog.scenarios': {
    one: '{count} сценарий',
    few: '{count} сценария',
    many: '{count} сценариев',
    other: '{count} сценария',
  },
  'automation.catalog.checks': {
    one: '{count} проверка',
    few: '{count} проверки',
    many: '{count} проверок',
    other: '{count} проверки',
  },
  'automation.catalog.repos': {
    one: '{count} репозиторий',
    few: '{count} репозитория',
    many: '{count} репозиториев',
    other: '{count} репозитория',
  },
};
